import { ConnectionErrorIllustration } from 'assets/illustrations';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePageViewEvent } from 'shared/gtm/hooks';

function Error() {
  const [searchParams] = useSearchParams();
  const errorQueryParam = searchParams.get('code');

  usePageViewEvent();

  const getHeader = useCallback((code: string | null) => {
    switch (code) {
      case '403':
        return '403 Not Authorized';
      case '404':
        return '404 Not Found';
      default:
        return 'Unknown Error';
    }
  }, []);

  return (
    <div className="pt-[56px] md:pt-[60px] absolute inset-0 text-black flex flex-col items-center justify-center">
      <ConnectionErrorIllustration />
      <div className="text-3xl font-bold uppercase mt-2">{getHeader(errorQueryParam)}</div>
      <p className="text-xl font-semibold text-center mt-4">An error happened when trying to view this page</p>
    </div>
  );
}

export default Error;
